import React from 'react';
const ArticlesContext = React.createContext();

export default ArticlesContext;